import { ThemeProvider } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { hotjar } from 'react-hotjar';
import { HOTJAR_CONFIG } from './config';
import { useAppStore } from './store/app-store.hook';
import { Theme as DefaultAppTheme } from './themes/default-theme';
import { Theme as LolAppTheme } from './themes/lol-theme';
import { Theme as TftAppTheme } from './themes/tft-theme';
import { Theme as ValorantAppTheme } from './themes/valorant-theme';
import { Theme as Diablo4AppTheme } from './themes/diablo-4-theme';
import { Theme as GenericGameAppTheme } from './themes/generic-game-theme';
import { DefaultTheme, LolTheme, ValorantTheme } from './ui/global/theme';
import { ProductAbbreviation } from './types/product';

export const App: React.FC = observer(() => {
  React.useEffect(() => {
    hotjar.initialize(HOTJAR_CONFIG.hjid, HOTJAR_CONFIG.hjsv, true);
  }, []);

  const { gameRegistryItem } = useAppStore().configStore;

  // A game gets a custom theme only when it has a case below; any other game from the registry gets the generic one.
  switch (gameRegistryItem?.gameAbbreviation) {
    case ProductAbbreviation.LOL:
      return (
        <ThemeProvider theme={LolTheme}>
          <LolAppTheme />
        </ThemeProvider>
      );
    case ProductAbbreviation.TFT:
      return (
        <ThemeProvider theme={LolTheme}>
          <TftAppTheme />
        </ThemeProvider>
      );
    case ProductAbbreviation.VALORANT:
      return (
        <ThemeProvider theme={ValorantTheme}>
          <ValorantAppTheme />
        </ThemeProvider>
      );
    case ProductAbbreviation.DIABLO_4:
      return (
        <ThemeProvider theme={DefaultTheme}>
          <Diablo4AppTheme />
        </ThemeProvider>
      );

    default:
      if (gameRegistryItem) {
        return (
          <ThemeProvider theme={DefaultTheme}>
            <GenericGameAppTheme gameName={gameRegistryItem.gameName} gameUrlSlug={gameRegistryItem.gameUrlSlug} />
          </ThemeProvider>
        );
      }

      return (
        <ThemeProvider theme={DefaultTheme}>
          <DefaultAppTheme />
        </ThemeProvider>
      );
  }
});
